import { useEffect, useRef } from "react";

const TICKER_CONFIG = {
  symbols: [
    { proName: "FX:EURUSD", title: "EUR/USD" },
    { proName: "FX:GBPUSD", title: "GBP/USD" },
    { proName: "FX:USDJPY", title: "USD/JPY" },
    { proName: "FX:AUDUSD", title: "AUD/USD" },
    { proName: "FX:USDCAD", title: "USD/CAD" },
    { proName: "FX:USDCHF", title: "USD/CHF" },
    { proName: "FX:NZDUSD", title: "NZD/USD" },
    { proName: "TVC:GOLD", title: "XAU/USD" },
  ],
  showSymbolLogo: false,
  isTransparent: true,
  displayMode: "compact",
  colorBackground: "#0b0b0b",
  locale: "en",
};

export default function Ticker() {
  const containerRef = useRef<HTMLDivElement>(null);
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    const widget = widgetRef.current;
    if (!container || !widget) return;

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify(TICKER_CONFIG);
    container.appendChild(script);

    return () => {
      script.remove();
      widget.innerHTML = "";
    };
  }, []);

  return (
    <div className="border-y-2 border-foreground-950 bg-primary-500 overflow-hidden min-h-[54px]" aria-hidden="true">
      <div className="tradingview-widget-container" ref={containerRef}>
        <div className="tradingview-widget-container__widget" ref={widgetRef}></div>
      </div>
    </div>
  );
}